import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  TagLabel,
  VStack,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from '@chakra-ui/react';
import Select from 'react-select';
import axios from 'axios';

const CertificateSpecializationRelation = () => {
  const [certificate, setCertificate] = useState(null);
  const [issuingAuthority, setIssuingAuthority] = useState(null);
  const [validityPeriod, setValidityPeriod] = useState(null);
  const [specializations, setSpecializations] = useState([]);
  const [validationApi, setValidationApi] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [existingData, setExistingData] = useState([]);
  const [certificatesOptions, setCertificatesOptions] = useState([]);
  const [issuingAuthoritiesOptions, setIssuingAuthoritiesOptions] = useState([]);
  const [specializationsOptions, setSpecializationsOptions] = useState([]);
  const [validityPeriods] = useState([
    { value: '3m', label: '3 Months' },
    { value: '6m', label: '6 Months' },
    { value: '1y', label: '1 Year' },
    { value: '2y', label: '2 Years' },
  ]);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteCertificateName, setDeleteCertificateName] = useState('');
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [updateCertificate, setUpdateCertificate] = useState(null);
  const [updateIssuingAuthority, setUpdateIssuingAuthority] = useState(null);
  const [updateValidityPeriod, setUpdateValidityPeriod] = useState(null);
  const [updateSpecializations, setUpdateSpecializations] = useState([]);
  const [updateValidationApi, setUpdateValidationApi] = useState('');
  const cancelDeleteRef = React.useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isUpdateOpen, onOpen: onUpdateOpen, onClose: onUpdateClose } = useDisclosure();

  useEffect(() => {
    fetchOptions();
    fetchRelations();
  }, []);

  const fetchOptions = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const [certificatesResponse, issuingAuthoritiesResponse, specializationsResponse] = await Promise.all([
        axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-certificates`,{
          headers: {
              Authorization: `Bearer ${ticketToken}`
          }
        }),
        axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-issuing-authorities`,{
          headers: {
              Authorization: `Bearer ${ticketToken}`
          }
        }),
        axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-specializations`,{
          headers: {
              Authorization: `Bearer ${ticketToken}`
          }
        }),
      ]);

      setCertificatesOptions(certificatesResponse.data.data.map(cert => ({ value: cert._id, label: cert.name })));
      setIssuingAuthoritiesOptions(issuingAuthoritiesResponse.data.data.map(auth => ({ value: auth._id, label: auth.name })));
      setSpecializationsOptions(specializationsResponse.data.data.map(spec => ({ value: spec._id, label: spec.name })));
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };

  const fetchRelations = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-certificate-specialization-relations`,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      setExistingData(response.data.data);
    } catch (error) {
      console.error('Error fetching relations:', error);
    }
  };

  const handleSubmit = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const newRelation = {
        certificateId: certificate.value,
        issuingAuthorityId: issuingAuthority.value,
        validityPeriod: validityPeriod.value,
        specializations: specializations.map(spec => spec.value),
        validationApi,
      };
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/add-certificate-specialization-relation`, newRelation,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchRelations();
      setCertificate(null);
      setIssuingAuthority(null);
      setValidityPeriod(null);
      setSpecializations([]);
      setValidationApi('');
      onClose();
    } catch (error) {
      console.error('Error adding relation:', error);
    }
  };

  const handleUpdate = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
        const updatedRelation = {
            id: updateId, // Include updateId in the request body
            certificateId: updateCertificate.value,
            issuingAuthorityId: updateIssuingAuthority.value,
            validityPeriod: updateValidityPeriod.value,
            specializations: updateSpecializations.map(spec => spec.value),
            validationApi: updateValidationApi,
        };
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/admin/update-certificate-specialization-relation`, updatedRelation,{
          headers: {
              Authorization: `Bearer ${ticketToken}`
          }
        });
        fetchRelations();
        setUpdateId(null);
        setUpdateCertificate(null);
        setUpdateIssuingAuthority(null);
        setUpdateValidityPeriod(null);
        setUpdateSpecializations([]);
        setUpdateValidationApi('');
        onUpdateClose();
    } catch (error) {
        console.error('Error updating relation:', error);
    }
};

  const handleDelete = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
        await axios.delete(`${process.env.REACT_APP_SERVER_URL}/admin/delete-certificate-specialization-relation`, {
            data: { id: deleteId } // Include deleteId in the request body  
        },{
          headers: {
              Authorization: `Bearer ${ticketToken}`
          }
        });
        fetchRelations();
        setIsDeleteAlertOpen(false);
    } catch (error) {
        console.error('Error deleting relation:', error);
    }
};
  const filteredData = existingData.filter(item =>
    item.certificate?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEdit = (item) => {
    setUpdateId(item._id);
    setUpdateCertificate(certificatesOptions.find(cert => cert.label === item.certificate));
    setUpdateIssuingAuthority(issuingAuthoritiesOptions.find(auth => auth.label === item.issuingAuthority));
    setUpdateValidityPeriod(validityPeriods.find(period => period.value === item.validityPeriod));
    setUpdateSpecializations(specializationsOptions.filter(spec => item.specializations.includes(spec.label)));
    setUpdateValidationApi(item.validationApi);
    onUpdateOpen();
  };

  return (
    <Box p={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading>Certificate Specialization Relation</Heading>
        <Button colorScheme="teal" onClick={onOpen}  position="absolute" top="10px" right="10px" zIndex="1000">
          Add
        </Button>
      </Flex>

      <Input
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        mb={4}
      />

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Certificate</Th>
            <Th>Issuing Authority</Th>
            <Th>Validity Period</Th>
            <Th>Specializations</Th>
            <Th>Validation API</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.map((item, index) => (
            <Tr key={index}>
              <Td>{item.certificate}</Td>
              <Td>{item.issuingAuthority}</Td>
              <Td>{item.validityPeriod}</Td>
              <Td>
                {item.specializations.map((spec, i) => (
                  <Tag key={i} m={1}>
                    <TagLabel>{spec}</TagLabel>
                  </Tag>
                ))}
              </Td>
              <Td>
                <Box
                  as="a"
                  href={item.validationApi}
                  target="_blank"
                  rel="noopener noreferrer"
                  fontSize="sm"
                  maxW="200px"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                >
                  {item.validationApi}
                </Box>
              </Td>
              <Td>
                <Button size="sm" colorScheme="blue" onClick={() => handleEdit(item)}>
                  Edit
                </Button>
                <Button size="sm" colorScheme="red" onClick={() => {
                  setDeleteId(item._id);
                  setDeleteCertificateName(item.certificate);
                  setIsDeleteAlertOpen(true);
                }}>
                  Delete
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Relation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <FormControl>
                <FormLabel>Certificate</FormLabel>
                <Select
                  options={certificatesOptions}
                  value={certificate}
                  onChange={setCertificate}
                  placeholder="Select Certificate"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Issuing Authority</FormLabel>
                <Select
                  options={issuingAuthoritiesOptions}
                  value={issuingAuthority}
                  onChange={setIssuingAuthority}
                  placeholder="Select Issuing Authority"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Validity Period</FormLabel>
                <Select
                  options={validityPeriods}
                  value={validityPeriod}
                  onChange={setValidityPeriod}
                  placeholder="Select Validity Period"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Specializations</FormLabel>
                <Select
                  isMulti
                  options={specializationsOptions}
                  value={specializations}
                  onChange={setSpecializations}
                  placeholder="Select Specializations"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Validation API</FormLabel>
                <Input
                  placeholder="Enter Validation API URL"
                  value={validationApi}
                  onChange={(e) => setValidationApi(e.target.value)}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
              Submit
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUpdateOpen} onClose={onUpdateClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Relation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <FormControl>
                <FormLabel>Certificate</FormLabel>
                <Select
                  options={certificatesOptions}
                  value={updateCertificate}
                  onChange={setUpdateCertificate}
                  placeholder="Select Certificate"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Issuing Authority</FormLabel>
                <Select
                  options={issuingAuthoritiesOptions}
                  value={updateIssuingAuthority}
                  onChange={setUpdateIssuingAuthority}
                  placeholder="Select Issuing Authority"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Validity Period</FormLabel>
                <Select
                  options={validityPeriods}
                  value={updateValidityPeriod}
                  onChange={setUpdateValidityPeriod}
                  placeholder="Select Validity Period"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Specializations</FormLabel>
                <Select
                  isMulti
                  options={specializationsOptions}
                  value={updateSpecializations}
                  onChange={setUpdateSpecializations}
                  placeholder="Select Specializations"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Validation API</FormLabel>
                <Input
                  placeholder="Enter Validation API URL"
                  value={updateValidationApi}
                  onChange={(e) => setUpdateValidationApi(e.target.value)}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleUpdate}>
              Update
            </Button>
            <Button variant="ghost" onClick={onUpdateClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={cancelDeleteRef}
        onClose={() => setIsDeleteAlertOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Relation
            </AlertDialogHeader>

            <AlertDialogBody>
              <FormControl>
                <FormLabel>Type the certificate name to confirm deletion:</FormLabel>
                <Input
                  placeholder="Certificate Name"
                  value={deleteCertificateName}
                  onChange={(e) => setDeleteCertificateName(e.target.value)}
                />
              </FormControl>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelDeleteRef} onClick={() => setIsDeleteAlertOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3} isDisabled={deleteCertificateName !== existingData.find(item => item._id === deleteId)?.certificate}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default CertificateSpecializationRelation;